import { Navigate } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';

interface IAuthGuardProps {
  permission: string | null;
  children: React.ReactNode;
}

const AuthGuard = ({ permission, children }: IAuthGuardProps) => {
  const { currentUser } = useAuth();

  if (permission === null) {
    return <>{children}</>;
  }

  if (currentUser?.isOwner) {
    return <>{children}</>;
  }

  if (currentUser?.permissions?.includes(permission)) {
    return <>{children}</>;
  }

  return <Navigate to="/dashboard" replace />;
};

export default AuthGuard;
